import { schema } from "normalizr";

export const propertyOptionsSchema = new schema.Entity("propertyOptions");